var React = require('react');

function Menos (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19 1.5119c0 .12461-.0647.23651-.1952.33731C18.6733 1.95 18.5182 2 18.3373 2H1.66267c-.18082 0-.33596-.05-.46644-.15079C1.06473 1.74841 1 1.63651 1 1.5119c0-.13968.06473-.25952.19623-.36031C1.32671 1.05079 1.48185 1 1.66267 1H18.3373c.1809 0 .336.05079.4675.15159.1305.10079.1952.22063.1952.36031Z","key":0}),React.createElement("path",{"d":"M19 1.5119c0 .12461-.0647.23651-.1952.33731C18.6733 1.95 18.5181 2 18.3373 2H1.66267c-.18082 0-.33596-.05-.46644-.15079C1.06473 1.74841 1 1.63651 1 1.5119c0-.13968.06473-.25952.19623-.36031C1.32671 1.05079 1.48185 1 1.66267 1H18.3373c.1808 0 .336.05079.4675.15159.1305.10079.1952.22063.1952.36031","strokeWidth":".5","key":1})]);
}

Menos.defaultProps = {"width":"20","height":"3","viewBox":"0 0 20 3","fill":"none","stroke":"none","className":"icon"};

module.exports = Menos;

Menos.default = Menos;
